import "./NewFooter.css";
import logo from "../../assets/images/Mountain-mystries-logo.png";
import unmeteredGif from "../../assets/images/unmetered-gif.gif";
import { animateScroll as scroll } from "react-scroll";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

function NewFooter() {
  const [userType, setUserType] = useState("");
  const [loader, setLoader] = useState(false);
  const userToken = localStorage.getItem("userToken");
  // console.log(userToken, "token");

  const [footerDestinations, setFooterDestinations] = useState([]);
  useEffect(() => {
    const storedUserType = localStorage.getItem("userType");
    if (storedUserType) {
      setUserType(storedUserType);
    }
  }, []);

  const location = useLocation();

  useEffect(() => {
    // window.scrollTo(0, 0);
    fetchDestinations();
  }, []);

  const fetchDestinations = async () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formData = new FormData();
    formData.append("limit", 10);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: formData,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setFooterDestinations(result?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <section className="NewFooter_background ">
        <div className="container">
          {/* Links */}
          <div className="NewFooter_Links">
            <div className="NewFooter_linksMain flex">
              <div className="NewFooter_MainCards NewFooter_Border">
                <div className="NewFooter_linksCards ">
                  <h4>Our Products</h4>
                  <ul className="p_0">
                    <li>
                      <Link
                        onClick={() =>
                          scroll.scrollToTop({
                            duration: 500,
                            smooth: "easeInOutQuad",
                          })
                        }
                        to="/all-hotels"
                      >
                        Hotels
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          scroll.scrollToTop({
                            duration: 500,
                            smooth: "easeInOutQuad",
                          })
                        }
                        to="/all-packages"
                      >
                        Holidays
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          scroll.scrollToTop({
                            duration: 500,
                            smooth: "easeInOutQuad",
                          })
                        }
                        to="/all-destinations"
                      >
                        Destinations
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          scroll.scrollToTop({
                            duration: 500,
                            smooth: "easeInOutQuad",
                          })
                        }
                        to="/themes"
                      >
                        Themes
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="NewFooter_MainCards NewFooter_Border flex justify_content_center">
                <div className="NewFooter_linksCards ">
                  <h4>Popular Destinations</h4>
                  {footerDestinations.slice(0, 5)?.map((data, index) => (
                    <div>
                      <ul className="p_0">
                        <li>
                          {" "}
                          <Link
                            onClick={() =>
                              scroll.scrollToTop({
                                duration: 500,
                                smooth: "easeInOutQuad",
                              })
                            }
                            key={index}
                            to={`/all-destinations/${data.name.toLowerCase()}`}
                          >
                            {data.name}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  ))}{" "}
                </div>
              </div>
              <div className="NewFooter_MainCards NewFooter_Border flex justify_content_center">
                <div className="NewFooter_linksCards ">
                  <h4>Company</h4>
                  <ul className="p_0">
                    <li to="">
                      <Link
                        to="/about"
                        onClick={() =>
                          scroll.scrollToTop({
                            duration: 500,
                            smooth: "easeInOutQuad",
                          })
                        }
                      >
                        About Us
                      </Link>
                      <li>
                        {" "}
                        <Link
                          to="/contact-us"
                          onClick={() =>
                            scroll.scrollToTop({
                              duration: 500,
                              smooth: "easeInOutQuad",
                            })
                          }
                        >
                          Contact Us
                        </Link>
                      </li>
                    </li>
                    <li>
                      {" "}
                      <Link to="/health-safety">Health & Safety</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="NewFooter_MainCards flex justify_content_center">
                <div className="NewFooter_linksCards ">
                  <h4>Useful Links</h4>
                  <ul className="p_0">
                    <li>
                      <Link
                        to="/login/vendor"
                        onClick={() =>
                          scroll.scrollToTop({
                            duration: 500,
                            smooth: "easeInOutQuad",
                          })
                        }
                      >
                        Vendor Login
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/login/agent"
                        onClick={() =>
                          scroll.scrollToTop({
                            duration: 500,
                            smooth: "easeInOutQuad",
                          })
                        }
                      >
                        Agent Login
                      </Link>
                    </li>
                    <li className="p_0">
                      {" "}
                      {userType === "customer" && (
                        <Link to="/customer-booking?role=bookings">
                          My Booking
                        </Link>
                      )}{" "}
                    </li>
                    <li>
                      {" "}
                      {userType === "customer" && (
                        <Link to="/customer-profile?role=profile">
                          My Account
                        </Link>
                      )}
                    </li>
                    <li>
                      {userType === "agent" && (
                        <Link to="/agent-account?role=bookings">
                          My Booking
                        </Link>
                      )}
                    </li>
                    <li>
                      {" "}
                      {userType === "agent" && (
                        <Link to="/agent-account?role=profile">My Account</Link>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Logo */}
          <div className="NewFooter_Logo flex justify_content_center">
            <div className="NewFooter_logoImg">
              <Link to="/">
                <img src={logo} alt="" />
              </Link>
            </div>
            <div className="NewFooter_Logo_line"></div>
          </div>

          {/* Info */}
          <div className="NewFooter_info flex">
            <div className="NewFooter_copyRight">
              <span className="copy">
                © Copyright 2024. All Rights Reserved.
              </span>
              <p>
                <b>Disclaimer</b> : All travel packages and services listed on
                this website are subject to availability and may change without
                prior notice. Prices, inclusions, and itineraries are not
                guaranteed until full payment is confirmed. The agency is not
                liable for any delays, cancellations, or issues caused by
                third-party providers or unforeseen events. We recommend
                travelers review all terms and conditions before booking. By
                using this site, you agree to comply with the policies stated.
              </p>
            </div>
            <div className="NewFooter_social flex flex_direction_col">
              <div className="NewFooter_socialLinks flex justify_content_end">
                <div className="NewFooter_socialLinks_cards">
                  <Link
                    to="https://www.facebook.com/mountainmysteries.in"
                    target="_blank"
                  >
                    <div className="flex_align_center">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.75 8.4375H10.3125L10.9375 5.9375H8.75V4.6875C8.75 4.04375 8.75 3.4375 10 3.4375H10.9375V1.3375C10.7337 1.31063 9.96437 1.25 9.15187 1.25C7.455 1.25 6.25 2.28562 6.25 4.1875V5.9375H4.375V8.4375H6.25V13.75H8.75V8.4375Z"
                          fill="#016937"
                        />
                      </svg>
                    </div>
                  </Link>
                </div>
                <div className="NewFooter_socialLinks_cards">
                  <Link
                    to="https://www.instagram.com/mountainmysteries/"
                    target="_blank"
                  >
                    <div className="flex_align_center">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.875 1.25H10.125C12.125 1.25 13.75 2.875 13.75 4.875V10.125C13.75 11.0864 13.3681 12.0084 12.6883 12.6883C12.0084 13.3681 11.0864 13.75 10.125 13.75H4.875C2.875 13.75 1.25 12.125 1.25 10.125V4.875C1.25 3.91359 1.63192 2.99156 2.31174 2.31174C2.99156 1.63192 3.91359 1.25 4.875 1.25ZM4.75 2.5C4.15326 2.5 3.58097 2.73705 3.15901 3.15901C2.73705 3.58097 2.5 4.15326 2.5 4.75V10.25C2.5 11.4937 3.50625 12.5 4.75 12.5H10.25C10.8467 12.5 11.419 12.2629 11.841 11.841C12.2629 11.419 12.5 10.8467 12.5 10.25V4.75C12.5 3.50625 11.4937 2.5 10.25 2.5H4.75ZM10.7812 3.4375C10.9885 3.4375 11.1872 3.51981 11.3337 3.66632C11.4802 3.81284 11.5625 4.01155 11.5625 4.21875C11.5625 4.42595 11.4802 4.62466 11.3337 4.77118C11.1872 4.91769 10.9885 5 10.7812 5C10.574 5 10.3753 4.91769 10.2288 4.77118C10.0823 4.62466 10 4.42595 10 4.21875C10 4.01155 10.0823 3.81284 10.2288 3.66632C10.3753 3.51981 10.574 3.4375 10.7812 3.4375ZM7.5 4.375C8.3288 4.375 9.12366 4.70424 9.70971 5.29029C10.2958 5.87634 10.625 6.6712 10.625 7.5C10.625 8.3288 10.2958 9.12366 9.70971 9.70971C9.12366 10.2958 8.3288 10.625 7.5 10.625C6.6712 10.625 5.87634 10.2958 5.29029 9.70971C4.70424 9.12366 4.375 8.3288 4.375 7.5C4.375 6.6712 4.70424 5.87634 5.29029 5.29029C5.87634 4.70424 6.6712 4.375 7.5 4.375ZM7.5 5.625C7.00272 5.625 6.52581 5.82254 6.17417 6.17417C5.82254 6.52581 5.625 7.00272 5.625 7.5C5.625 7.99728 5.82254 8.47419 6.17417 8.82583C6.52581 9.17746 7.00272 9.375 7.5 9.375C7.99728 9.375 8.47419 9.17746 8.82583 8.82583C9.17746 8.47419 9.375 7.99728 9.375 7.5C9.375 7.00272 9.17746 6.52581 8.82583 6.17417C8.47419 5.82254 7.99728 5.625 7.5 5.625Z"
                          fill="#016937"
                        />
                      </svg>
                    </div>
                  </Link>
                </div>
                {/* <div className="NewFooter_socialLinks_cards">
                                    <Link to="" target="_blank">
                                        <div className="flex_align_center">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_4496_2478)">
                                                    <mask id="mask0_4496_2478" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                                                        <path d="M0 -3.05176e-05H12V12H0V-3.05176e-05Z" fill="white" />
                                                    </mask>
                                                    <g mask="url(#mask0_4496_2478)">
                                                        <path d="M9.45 0.562256H11.2903L7.27029 5.16854L12 11.4377H8.29714L5.39486 7.63626L2.07771 11.4377H0.235714L4.53514 6.50911L0 0.563113H3.79714L6.41657 4.03711L9.45 0.562256ZM8.80286 10.3337H9.82286L3.24 1.60883H2.14629L8.80286 10.3337Z" fill="#016937" />
                                                    </g>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_4496_2478">
                                                        <rect width="12" height="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </div>
                                    </Link>
                                </div> */}
                <div className="NewFooter_socialLinks_cards">
                  <Link
                    to="https://www.youtube.com/channel/UCLCvoKy9UnH6f8nvax44R8w"
                    target="_blank"
                  >
                    <div className="flex_align_center">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.2544 4.37187C12.2069 4.18562 12.0719 4.045 11.9175 4.00187C11.6438 3.925 10.3131 3.75 7.50063 3.75C4.68813 3.75 3.35813 3.925 3.0825 4.00187C2.93 4.04437 2.795 4.185 2.74688 4.37187C2.67875 4.63687 2.50062 5.74688 2.50062 7.5C2.50062 9.2525 2.67875 10.3625 2.74688 10.6287C2.79437 10.8144 2.92938 10.955 3.08313 10.9975C3.35812 11.075 4.6875 11.25 7.5 11.25C10.3125 11.25 11.6431 11.075 11.9181 10.9981C12.0706 10.9556 12.2056 10.815 12.2538 10.6281C12.3225 10.3631 12.5 9.25 12.5 7.5C12.5 5.75 12.3225 4.6375 12.2544 4.37187ZM13.4644 4.06125C13.75 5.175 13.75 7.5 13.75 7.5C13.75 7.5 13.75 9.825 13.4644 10.9388C13.3056 11.5544 12.8412 12.0387 12.2531 12.2025C11.1856 12.5 7.5 12.5 7.5 12.5C7.5 12.5 3.81687 12.5 2.74688 12.2025C2.15625 12.0363 1.6925 11.5525 1.53563 10.9388C1.25 9.825 1.25 7.5 1.25 7.5C1.25 7.5 1.25 5.175 1.53563 4.06125C1.69438 3.44563 2.15875 2.96125 2.74688 2.7975C3.8175 2.5 7.50063 2.5 7.50063 2.5C7.50063 2.5 11.1856 2.5 12.2538 2.7975C12.8438 2.96375 13.3081 3.4475 13.465 4.06125M6.25063 9.6875V5.3125L10.0006 7.5L6.25063 9.6875Z"
                          fill="#016937"
                        />
                      </svg>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="NewFooter_detailsLinks flex">
                <Link to="/term-conditions">Terms & Conditions</Link>
                <Link to="/cancellation-policy">Cancelletion Policy</Link>
                <Link to="/disclaimer">Disclaimer</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </div>
              <div className="unmetered-gif unmetered_mob justify_content_end">
                <p> Powered By</p>
                <Link to="https://unmeteredtechnologies.com/">
                  <img
                    src={unmeteredGif}
                    alt="unmetered-gif"
                    style={{ height: "auto", width: "75px" }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NewFooter;
